import*as e from"react";const t=e.createContext({lineId:void 0});export{t as LineContext};
//# sourceMappingURL=line.js.map
